function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "logo",
  transform: "translate(194 252.996)"
}, React.createElement("g", {
  id: "Layer_1",
  "data-name": "Layer 1"
}, React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  className: "cls-1",
  d: "M1,41.007c3.981-14.371,14.988-27.2,29.458-34.658A56.312,56.312,0,0,1,54.13.056a70.661,70.661,0,0,1,24.3,3.327,58.978,58.978,0,0,1,20.938,11.7,63.185,63.185,0,0,1,8.011,8.519l1.7,2.36.821,1.164.763,1.211,1.535,2.344c.484.787.911,1.66,1.363,2.486a76.582,76.582,0,0,1,4.482,10.273l.821,2.651c.263.889.575,1.754.772,2.659.435,1.793.927,3.563,1.207,5.38l.484,2.7c.123.9.222,1.817.337,2.722.254,1.8.353,3.618.451,5.428l.074,1.361v4.075c0,1.8-.2,3.6-.3,5.4h-1.4c-.164-1.77-.263-3.532-.484-5.278l-.378-2.619-.189-1.306-.254-1.314-.509-2.58c-.148-.865-.419-1.707-.616-2.556s-.427-1.7-.665-2.541l-.821-2.494c-.484-1.675-1.174-3.28-1.773-4.916-.279-.787-.673-1.573-1.018-2.36l-1.059-2.36a72.528,72.528,0,0,0-5.228-8.936c-.492-.7-.952-1.424-1.469-2.108l-1.584-2.022-.821-1.007-.821-.952-1.674-1.927a55.677,55.677,0,0,0-7.674-6.623,49.127,49.127,0,0,0-18.14-8.252,50.87,50.87,0,0,0-19.83-.425,93.225,93.225,0,0,0-19.034,5.2,85.449,85.449,0,0,0-17.836,9.439c-2.848,2.022-5.581,4.153-8.315,6.442s-5.327,4.8-8.085,7.378Z",
  transform: "translate(-1 13)"
}), React.createElement("circle", {
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  className: "cls-1",
  cx: 7.01,
  cy: 7.01,
  r: 7.01,
  transform: "translate(31.38 52.23)"
}), React.createElement("rect", {
  id: "Rectangle_1",
  "data-name": "Rectangle 1",
  className: "cls-1",
  width: 122,
  height: 20,
  rx: 6.15,
  transform: "translate(0.19 126.3)"
}), React.createElement("rect", {
  id: "Rectangle_2",
  "data-name": "Rectangle 2",
  className: "cls-1",
  width: 20,
  height: 99.35,
  rx: 8.63,
  transform: "translate(0 46.25)"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Group_1",
    "data-name": "Group 1",
    viewBox: "194 266 122.19 133.296",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.06305d66.svg";
export { ForwardRef as ReactComponent };